const Icons = {
  check: 'e900',
  checks: 'e901',
  activesessions: 'e902',
  add: 'e903',
  add_chat: 'e904',
  add_reaction: 'e905',
  addboost: 'e906',
  addmember_filled: 'e907',
  adduser: 'e908',
  admin: 'e909',
  ads: 'e90a',
  ai_letters: 'e90b',
  ai_star1: 'e90c',
  ai_star2: 'e90d',
  ai_style_tone: 'e90e',
  align_center: 'e90f',
  align_left: 'e910',
  align_right: 'e911',
  animals: 'e912',
  animations: 'e913',
  app_expand: 'e914',
  app_shrink: 'e915',
  archive: 'e916',
  archive_filled: 'e917',
  arrow_down: 'e918',
  arrow_next: 'e919',
  arrow_prev: 'e91a',
  arrow_up_circle_fill: 'e91b',
  arrowcircle: 'e91c',
  arrowhead: 'e91d',
  attach: 'e91e',
  attach_edit: 'e91f',
  audio_repeat: 'e920',
  audio_repeat_single: 'e921',
  author_hidden: 'e922',
  auto_delete_circle_1: 'e923',
  auto_delete_circle_2: 'e924',
  auto_delete_circle_3: 'e925',
  auto_delete_circle_4: 'e926',
  auto_delete_circle_5: 'e927',
  auto_delete_circle_6: 'e928',
  auto_delete_circle_7: 'e929',
  auto_delete_circle_8: 'e92a',
  auto_delete_circle_clock: 'e92b',
  auto_delete_circle_days: 'e92c',
  auto_delete_circle_empty: 'e92d',
  auto_delete_circle_hours: 'e92e',
  auto_delete_circle_months: 'e92f',
  auto_delete_circle_off: 'e930',
  auto_delete_circle_weeks: 'e931',
  auto_delete_circle_years: 'e932',
  avatarnext: 'e933',
  avatarprevious: 'e934',
  aversion: 'e935',
  back: 'e936',
  backward_5: 'e937',
  binfilled: 'e938',
  bold: 'e939',
  bomb: 'e93a',
  boost: 'e93b',
  boostcircle: 'e93c',
  boosts: 'e93d',
  bot_filled: 'e93e',
  botcom: 'e93f',
  bots: 'e940',
  brightness: 'e941',
  brush: 'e942',
  bubblereply: 'e943',
  bug: 'e944',
  calendar: 'e945',
  calendarfilter: 'e946',
  camera: 'e947',
  cameraadd: 'e948',
  captiondown: 'e949',
  captionup: 'e94a',
  car: 'e94b',
  card: 'e94c',
  card_outline: 'e94d',
  cash_circle: 'e94e',
  channel: 'e94f',
  channel_filled: 'e950',
  channelviews: 'e951',
  chatspinned: 'e952',
  chatsplaceholder: 'e953',
  check1: 'e954',
  checkbox: 'e955',
  checkboxblock: 'e956',
  checkboxempty: 'e957',
  checkboxon: 'e958',
  checklist_add: 'e959',
  checklist_done: 'e95a',
  checklist_undone: 'e95b',
  checkretract: 'e95c',
  checkround: 'e95d',
  checkround_filled: 'e95e',
  clipboard: 'e95f',
  clock: 'e960',
  close: 'e961',
  clouddownload: 'e962',
  collapse: 'e963',
  colorize: 'e964',
  comments: 'e965',
  commentssticker: 'e966',
  contrast: 'e967',
  copy: 'e968',
  crop: 'e969',
  cross: 'e96a',
  crossgif: 'e96b',
  crossround: 'e96c',
  crossround_filled: 'e96d',
  crossstar: 'e96e',
  crown: 'e96f',
  crown_outline: 'e970',
  crownalt: 'e971',
  crownoff: 'e972',
  crownoff_outline: 'e973',
  darkmode: 'e974',
  darkmode_filled: 'e975',
  data: 'e976',
  delete: 'e977',
  delete_filled: 'e978',
  deletedaccount: 'e979',
  deleteleft: 'e97a',
  deleteuser: 'e97b',
  devices: 'e97c',
  document: 'e97d',
  dollar_circle: 'e97e',
  dollar_circle_x: 'e97f',
  down: 'e980',
  down_crossed: 'e981',
  down_up: 'e982',
  download: 'e983',
  dragfiles: 'e984',
  dragmedia: 'e985',
  eats: 'e986',
  edit: 'e987',
  edit_stars: 'e988',
  edit_stars_add: 'e989',
  email: 'e98a',
  endcall_filled: 'e98b',
  enhance: 'e98c',
  enter: 'e98d',
  equalizer: 'e98e',
  expand: 'e98f',
  eye: 'e990',
  eye1: 'e991',
  eye2: 'e992',
  eyecross_outline: 'e993',
  faceid: 'e994',
  factcheck: 'e995',
  fade: 'e996',
  fast_forward: 'e997',
  fast_rewind: 'e998',
  favourites: 'e999',
  filter: 'e99a',
  fire: 'e99b',
  flag: 'e99c',
  flip: 'e99d',
  flip_image_horizontal: 'e99e',
  folder: 'e99f',
  fontframe: 'e9a0',
  fontframe_bg: 'e9a1',
  fontframe_outline: 'e9a2',
  fontsize: 'e9a3',
  forward: 'e9a4',
  forward_25: 'e9a5',
  forward_filled: 'e9a6',
  free_transform: 'e9a7',
  fullscreen: 'e9a8',
  gc_microphone: 'e9a9',
  gc_microphoneoff: 'e9aa',
  gem: 'e9ab',
  gem_exchange: 'e9ac',
  gem_transfer: 'e9ad',
  gem_transfer_outline: 'e9ae',
  geometric_digit_0: 'e9af',
  geometric_digit_1: 'e9b0',
  geometric_digit_2: 'e9b1',
  geometric_digit_3: 'e9b2',
  geometric_digit_4: 'e9b3',
  geometric_digit_5: 'e9b4',
  geometric_digit_6: 'e9b5',
  geometric_digit_7: 'e9b6',
  geometric_digit_8: 'e9b7',
  geometric_digit_9: 'e9b8',
  geometric_dot: 'e9b9',
  geometric_letter_x: 'e9ba',
  gifs: 'e9bb',
  gift: 'e9bc',
  gift_premium: 'e9bd',
  grain: 'e9be',
  group: 'e9bf',
  group_filled: 'e9c0',
  group_star: 'e9c1',
  groupmedia: 'e9c2',
  groupmediaoff: 'e9c3',
  hand: 'e9c4',
  help: 'e9c5',
  hide: 'e9c6',
  highlights: 'e9c7',
  hourglass: 'e9c8',
  image: 'e9c9',
  image_original: 'e9ca',
  info: 'e9cb',
  info2: 'e9cc',
  italic: 'e9cd',
  key: 'e9ce',
  keyboard: 'e9cf',
  lamp: 'e9d0',
  language: 'e9d1',
  largepause: 'e9d2',
  largeplay: 'e9d3',
  left: 'e9d4',
  limit_chat: 'e9d5',
  limit_chats: 'e9d6',
  limit_file: 'e9d7',
  limit_folders: 'e9d8',
  limit_link: 'e9d9',
  limit_pin: 'e9da',
  link: 'e9db',
  link_paid: 'e9dc',
  list: 'e9dd',
  listscreenshare: 'e9de',
  livelocation: 'e9df',
  livestream: 'e9e0',
  location: 'e9e1',
  lock: 'e9e2',
  lockoff: 'e9e3',
  loginlogodesktop: 'e9e4',
  loginlogomobile: 'e9e5',
  logo: 'e9e6',
  logout: 'e9e7',
  mac_command_key: 'e9e8',
  mediaspeed_empty: 'e9e9',
  mediaspoiler: 'e9ea',
  mediaspoileroff: 'e9eb',
  mention: 'e9ec',
  menu: 'e9ed',
  menu_feature_cover: 'e9ee',
  menu_feature_unique: 'e9ef',
  menu_verification: 'e9f0',
  message: 'e9f1',
  message_jump: 'e9f2',
  message_quote: 'e9f3',
  messageunread: 'e9f4',
  microphone: 'e9f5',
  microphone_crossed: 'e9f6',
  microphone_crossed_filled: 'e9f7',
  microphone_filled: 'e9f8',
  minus: 'e9f9',
  monospace: 'e9fa',
  more: 'e9fb',
  movetochats: 'e9fc',
  movetomenu: 'e9fd',
  multistories: 'e9fe',
  music: 'e9ff',
  mute: 'ea00',
  muted: 'ea01',
  mynotes: 'ea02',
  newchannel: 'ea03',
  newchannel_filled: 'ea04',
  newchat_filled: 'ea05',
  newgroup: 'ea06',
  newgroup_filled: 'ea07',
  newprivate: 'ea08',
  newprivate_filled: 'ea09',
  newtab: 'ea0a',
  next: 'ea0b',
  nochannel: 'ea0c',
  noncontacts: 'ea0d',
  nosound: 'ea0e',
  note: 'ea0f',
  okay: 'ea10',
  online: 'ea11',
  passwordoff: 'ea12',
  pause: 'ea13',
  permissions: 'ea14',
  person: 'ea15',
  phone: 'ea16',
  phone_filled: 'ea17',
  pin: 'ea18',
  pin2: 'ea19',
  pinlist: 'ea1a',
  pinned_filled: 'ea1b',
  pinnedchat: 'ea1c',
  pinnedchat_filled: 'ea1d',
  pip: 'ea1e',
  play: 'ea1f',
  playback_05: 'ea20',
  playback_15: 'ea21',
  playback_1x: 'ea22',
  playback_2x: 'ea23',
  plus: 'ea24',
  plusround: 'ea25',
  poll: 'ea26',
  poll_multiple_answers: 'ea27',
  premium_addone: 'ea28',
  premium_avatars: 'ea29',
  premium_badge: 'ea2a',
  premium_colors: 'ea2b',
  premium_double: 'ea2c',
  premium_emoji: 'ea2d',
  premium_filesize: 'ea2e',
  premium_lastseen: 'ea2f',
  premium_limits: 'ea30',
  premium_lock: 'ea31',
  premium_management: 'ea32',
  premium_noads: 'ea33',
  premium_privacy: 'ea34',
  premium_reactions: 'ea35',
  premium_restrict: 'ea36',
  premium_speed: 'ea37',
  premium_status: 'ea38',
  premium_stickers: 'ea39',
  premium_tags: 'ea3a',
  premium_transcription: 'ea3b',
  premium_translate: 'ea3c',
  premium_unlock: 'ea3d',
  premium_wallpaper: 'ea3e',
  previous: 'ea3f',
  privacypolicy: 'ea40',
  promote: 'ea41',
  qr: 'ea42',
  quote: 'ea43',
  quote_outline: 'ea44',
  radiooff: 'ea45',
  radioon: 'ea46',
  reactions: 'ea47',
  reactions_filled: 'ea48',
  readchats: 'ea49',
  recent: 'ea4a',
  recordround: 'ea4b',
  redo: 'ea4c',
  reload_star: 'ea4d',
  replace: 'ea4e',
  reply: 'ea4f',
  reply_filled: 'ea50',
  restrict: 'ea51',
  revenue: 'ea52',
  rightpanel: 'ea53',
  rotate: 'ea54',
  rotate_left: 'ea55',
  rotate_right: 'ea56',
  round_chats_filled: 'ea57',
  saturation: 'ea58',
  saved: 'ea59',
  savedmessages: 'ea5a',
  schedule: 'ea5b',
  scheduled: 'ea5c',
  screen_crossed: 'ea5d',
  search: 'ea5e',
  search_check: 'ea5f',
  select: 'ea60',
  send: 'ea61',
  send2: 'ea62',
  sending: 'ea63',
  sendingerror: 'ea64',
  settings: 'ea65',
  settings_clipped_corner: 'ea66',
  settings_filled: 'ea67',
  shadows: 'ea68',
  sharescreen_filled: 'ea69',
  sharingoff: 'ea6a',
  sharingoff_filled: 'ea6b',
  sharingon: 'ea6c',
  sharpen: 'ea6d',
  shipping: 'ea6e',
  shuffle: 'ea6f',
  smallscreen: 'ea70',
  smile: 'ea71',
  sort_date: 'ea72',
  sort_num: 'ea73',
  sort_price: 'ea74',
  speaker: 'ea75',
  speakerfilled: 'ea76',
  speakeroff: 'ea77',
  speakerofffilled: 'ea78',
  spoiler: 'ea79',
  sport: 'ea7a',
  star: 'ea7b',
  star_filled: 'ea7c',
  statistics: 'ea7d',
  stickers: 'ea7e',
  stickers_face: 'ea7f',
  stop: 'ea80',
  stories: 'ea81',
  story: 'ea82',
  storyreply: 'ea83',
  storyrepost: 'ea84',
  strikethrough: 'ea85',
  suggested: 'ea86',
  tag: 'ea87',
  tag_add: 'ea88',
  tag_alt: 'ea89',
  tag_alt_crossed: 'ea8a',
  tag_alt_outline: 'ea8b',
  tag_crossed: 'ea8c',
  tag_filter: 'ea8d',
  tag_name: 'ea8e',
  text: 'ea8f',
  textedit: 'ea90',
  time_lock: 'ea91',
  timer: 'ea92',
  tip: 'ea93',
  ton: 'ea94',
  tools: 'ea95',
  topics: 'ea96',
  trade: 'ea97',
  transcribe: 'ea98',
  unarchive: 'ea99',
  unclaimed: 'ea9a',
  underline: 'ea9b',
  undo: 'ea9c',
  unmute: 'ea9d',
  unpack: 'ea9e',
  unpin: 'ea9f',
  unread: 'eaa0',
  up: 'eaa1',
  up_down: 'eaa2',
  user: 'eaa3',
  username: 'eaa4',
  videocamera: 'eaa5',
  videocamera_crossed_filled: 'eaa6',
  videocamera_filled: 'eaa7',
  videochat: 'eaa8',
  vignette: 'eaa9',
  volume_down: 'eaaa',
  volume_mute: 'eaab',
  volume_off: 'eaac',
  volume_up: 'eaad',
  warmth: 'eaae',
  warning: 'eaaf',
  webview: 'eab0',
  win_key: 'eab1',
  zoomin: 'eab2',
  zoomout: 'eab3'
};

export default Icons;
